import { render, staticRenderFns } from "./resetPw.vue?vue&type=template&id=6659dd7c&scoped=true&"
import script from "./resetPw.vue?vue&type=script&lang=js&"
export * from "./resetPw.vue?vue&type=script&lang=js&"
import style0 from "./resetPw.vue?vue&type=style&index=0&id=6659dd7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659dd7c",
  null
  
)

export default component.exports